import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useMemo } from "react";

// Components
import SolTableRow from "./SolTableRow/SolTableRow";
import ButtonsBlock from "./ButtonsBlock/ButtonsBlock";

// Hooks
import { useTokenTableSubmit } from "./useTokenTableSubmit";

// Utils
import { createYupSchema, TOKENS_TABLE_FIELDS } from "./validationSchema";

// Configs
import { SOL_MAX_DELTA } from "../../config";

const TokensTable = ({ tokens, solBalance, setSuccessRate }) => {
  const formattedMaxAmount = Number((solBalance - SOL_MAX_DELTA).toFixed(9));
  const maximumSolAmount = formattedMaxAmount >= 0 ? formattedMaxAmount : 0;
  const defaultValues = useMemo(
    () =>
      tokens.reduce(
        (acc, { mintAddress, tokenBalance }) => {
          acc[mintAddress] = {
            [TOKENS_TABLE_FIELDS.amount]: tokenBalance,
            [TOKENS_TABLE_FIELDS.checkbox]: true,
          };

          return acc;
        },
        {
          sol: {
            [TOKENS_TABLE_FIELDS.amount]: maximumSolAmount,
          },
        },
      ),
    [maximumSolAmount, tokens],
  );

  const methods = useForm({
    defaultValues,
    resolver: yupResolver(createYupSchema(tokens)),
    context: { tokens, solBalance: maximumSolAmount },
    mode: "all",
  });

  const { handleSubmit, reset, setError, trigger } = methods;
  const { onSubmit } = useTokenTableSubmit({
    reset,
    defaultValues,
    handleSubmit,
    setError,
    trigger,
  });

  return (
    <FormProvider {...methods}>
      <form onSubmit={onSubmit}>
        <div className="text-center min-w-[300px]">
          <SolTableRow setSuccessRate={setSuccessRate} />
        </div>
        <div className="flex justify-center mb-5">
          <ButtonsBlock solBalance={solBalance} defaultValues={defaultValues} />
        </div>
      </form>
    </FormProvider>
  );
};

export default TokensTable;

